import { tokensDemo } from './demos/TokensDemo';
import { bravoLogoDemo } from './demos/BravoLogoDemo';
import { buttonsDemo } from './demos/ButtonsDemo';
import { buttonRowDemo } from './demos/ButtonRowDemo';
import { badgesDemo } from './demos/BadgesDemo';
import { chipsDemo } from './demos/ChipsDemo';
import { segmentedToggleDemo } from './demos/SegmentedToggleDemo';
import { linksDemo } from './demos/LinksDemo';
import { cardsDemo } from './demos/CardsDemo';
import { messageCardDemo } from './demos/MessageCardDemo';
import { labeledValueBoxDemo } from './demos/LabeledValueBoxDemo';
import { reportLauncherDemo } from './demos/ReportLauncherDemo';
import { alertsDemo } from './demos/AlertsDemo';
import { loadersDemo } from './demos/LoadersDemo';
import { holidayLoadersDemo } from './demos/HolidayLoadersDemo';
import { paginationDemo } from './demos/PaginationDemo';
import { listPageDemo } from './demos/ListPageDemo';
import { searchStripDemo } from './demos/SearchStripDemo';
import { tabbedPageDemo } from './demos/TabbedPageDemo';
import { pageShellDemo } from './demos/PageShellDemo';
import { standalonePageDemo } from './demos/StandalonePageDemo';
import { notificationDemo } from './demos/NotificationDemo';
import { toastDemo } from './demos/ToastDemo';
import { confirmDialogsDemo } from './demos/ConfirmDialogsDemo';
import { wizardDemo } from './demos/WizardDemo';
import { inputsTextDemo } from './demos/InputsTextDemo';
import { inputsToggleDemo } from './demos/InputsToggleDemo';
import { inputsDateTimeDemo } from './demos/InputsDateTimeDemo';
import { inputsSelectDemo } from './demos/InputsSelectDemo';
import { inputsDataBoundDemo } from './demos/InputsDataBoundDemo';

// Central registry of design-system gallery demos. Adding a component to the
// gallery = one demo file in ./demos + one import + one array entry here.
// Descriptor shape: { id, title, category, importPath, notes, snippet, render }
export const demoRegistry = [
  tokensDemo,
  bravoLogoDemo,
  buttonsDemo,
  buttonRowDemo,
  badgesDemo,
  chipsDemo,
  segmentedToggleDemo,
  linksDemo,
  alertsDemo,
  loadersDemo,
  holidayLoadersDemo,
  cardsDemo,
  messageCardDemo,
  labeledValueBoxDemo,
  reportLauncherDemo,
  listPageDemo,
  searchStripDemo,
  paginationDemo,
  tabbedPageDemo,
  pageShellDemo,
  standalonePageDemo,
  notificationDemo,
  toastDemo,
  confirmDialogsDemo,
  wizardDemo,
  inputsTextDemo,
  inputsToggleDemo,
  inputsDateTimeDemo,
  inputsSelectDemo,
  inputsDataBoundDemo,
];
